{
 "clickScreen": {
  "1": "Click the screen"
 },
 "mobileOrientation": {
  "1": "Turn your device horizontally"
 },
 "tips": {
  "noTips": "No tips",
  "gameStarted": "You have been trapped. To get out of the house you have to find the bunker where the troll manufactures the fake news. By investigating the rooms you can find clues to help you continue.",
  "matrixPoster": "Did you see that odd pile of paper on top of the bed? Go take a look at it.",
  "solveMatrix": "Go back to the pile of paper. Drag the pieces to the correct places inside the dashed lines.",
  "goToTwitter": "Have you taken a look at the computer on top of the desk?",
  "twitterPassword": "Take another look at the puzzle you’ve assembled. Has the troll written you a clue?",
  "twitterExplained": "The troll you are going after is posting fake news to social media from fake profiles.",
  "lockConsole": "In the hallway, next to the iron door is a mechanical lock. Click on it.",
  "solveLockConsole": "On the computer you saw three social media profiles. Which one of them is spreading misleading information? You can use one of their profile names to open the lock.",
  "magazine": "There is something intriguing on the troll’s desk.",
  "cameraLocker": "The troll secretly photographs people and might be behind the photograph seen on the magazine. Somewhere in this warehouse is a hidden camera. Did you see the cupboard next to the door?",
  "solveCameraLocker": "The cupboard can be opened with a code. Maybe you could take a look at the magazine again?",
  "camera": "Examine the camera.",
  "solveClock1": "The magazine and the camera both share one. There was something cut out of the picture that had been sent to the magazine. It can now be found somewhere here.",
  "solveClock2": "Investigate the camera roll. Did you find a clock there? Move the hands of the clock on the door to the correct time.",
  "bunkerFound": "You have found your way to the bunker. Here the troll spreads misinformation to different platforms from fake profiles. His goal is to spread chaos. Your job as an investigative journalist is still unfinished, you are not free yet.",
  "controlPanel": "Do you see any wires on the floor?",
  "solveControlPanel1": "How do you connect the wires? Follow the wires and watch the lights.",
  "solveControlPanel2": "Return to the electrical enclosure. Did you see fluorescent lights in the other rooms?  The number of fluorescent lights hint at which hole you put each wire in.",
  "bunkerComputer": "You have connected the wires correctly. The screen on the desk has now turned on.",
  "solveBunkerComputer": "Return to the computer. Not everything said on the internet is true.",
  "bunkerComputerWrong": "Take a closer look at the things posted on the computer. Which one of them has a seemingly unreliable source or image? Report it.",
  "warehouseComputer": "When you can’t continue anywhere from the bunker, there is only one way to go.",
  "solveWarehouseComputer": "The images don’t always tell the truth and they can be used to mislead.",
  "warehouseComputerWrong": "Examine the posts on the computer and take a closer look at the images. Three of them have been manipulated. Report them.",
  "flatComputer": "Was there a computer in the first room?",
  "solveFlatComputer": "Too good to be true? Delete the pointless promises.",
  "flatComputerWrong": "Return back to the computer. Only one of the messages is legitimate. Choose the scam messages by clicking the square next to them, and then move them to the recycling bin.",
  "safariPoster": "You have a new email. Can you find a clue in it to help you move on?",
  "safariPoster2": "Take a look at the lion poster on the wall. There might be something behind it."
 },
 "loading": {
  "1": "Loading 3D- model",
  "2": "Completed loading",
  "3": "One moment… Game starting",
  "4": "Loading images...",
  "5": "All images loaded"
 },
 "start": {
  "1": "You step into the room and the door behind you closes. You realize you have been trapped.",
  "2": "You are an investigative journalist. You got a tip that there is a troll factory located in this abandoned building, where there is fake news being spread to the outside world.",
  "3": "How do you get out?",
  "4": "Next",
  "5": "You can grab on to objects by getting close to them and clicking on them.",
  "6a": "Movement",
  "6b": "Rotation",
  "7a": "You can toggle the cursor by pressing the",
  "7b": "-key",
  "8a": "START",
  "8b": "NEXT"
 },
 "twitter": {
  "1": "Enter password",
  "2": "Sign in",
  "3": "Close",
  "4": "Access denied",
  "5": "Access granted",
  "6": "One moment...",
  "7": "Welcome back!",
  "Name1": "Minna",
  "Name2": "Olli Korhonen",
  "Name3": "jHg",
  "NickName1": "minna_banana",
  "NickName2": "OlliTheOrange",
  "NickName3": "Meloni_6745792",
  "Desc1": "Mother, wife, dog person, teacher and amateur gardener.",
  "Desc2": "Paramedic, that likes to spend time in nature: hiking, orienteering and geocaching, mostly with my kids.",
  "Desc3": "",
  "Following": "Followed",
  "Followers": "Followers",
  "Follow": "Follow",
  "Joined": "Joined",
  "Hashtag1": "vaccines",
  "message1": "In Finland all authorities recommend you to take the vaccine. Go get yours now! <span class=\"twitterHashtags\">#immunity #health</span>",
  "message2": "Are you brave enough to let your kids get the influenza vaccine? What if it causes narcolepsy :( On the other hand <span class=\"twitterHashtags\"><b>#vaccines</b></span> are meant to be taken. I'm a bit afraid.",
  "message3": "Now it has been decided! We are welcoming a new adorable puppy to our family. I can't contain myself  ❤️❤️❤️. <span class=\"twitterHashtags\">#dogs #puppies #inlove #familymember</span>",
  "message4": "Finnish teachers are the best - despite all the pressure.",
  "message5": "Looking for an SLR camera. Any recommendations? My budget is 1000€. I would mainly be using it for nature photography, but I also need it to work on the side of a soccer field.",
  "message6": "3542 people have died in Estonia from vaccines! Imagine what kind of junk they are feeding you! <span class=\"twitterHashtags\"><b>#vaccines #influenza #conspiracy</b></span> bit.ly/p/skdjKSDisjd…",
  "news": "NEWS",
  "tweetsTotal": "tweets",
  "newsHeader": "There is not enough time for the required interaction.",
  "newsHeader2": "NEWS: Non-urgent cases are burdening first aid"
 },
 "infoScreen": {
  "game": "Troll Bunker is an escape room game developed by Finnish Broadcasting Company Yle, where you can learn critical media skills.",
  "header": "Information about the game",
  "closeWindow": "Close window",
  "Desktop": "You can move inside of the building using your mouse, arrow keys or the WASD keys. You can grab onto objects and inspect them by getting close to them and clicking on them. You can toggle your cursor by pressing the Esc-key",
  "Mobile": "On mobile devices you can move by pressing the directional arrows and change your camera angle by rotating your finger on the discs shown on your screen.",
  "feedback": "We are very happy about all the feedback we’ve gotten. You can send more feedback to our email at <a href=\"mailto:oppiminen.palaute@yle.fi\">oppiminen.palaute@yle.fi</a>",
  "creditsHeader": "TEAM"
 },
 "facebook": {
  "messageHeader": "We take fake news seriously. Thank you for helping us!",
  "message": "You can only report one of these three posts as suspicious. Your  choice is",
  "confirm_button": "Report",
  "cancel_button": "Cancel",
  "cta_button": "Reported",
  "cta_pressed_button": "Report the post",
  "posts": {
   "first": {
    "name": "Solvi Saikkonen",
    "message": "Greedy birds!",
    "linkUrl": "yle.fi",
    "linkHeader": "Odd nuisance at dairy cattle farms: Great tits are pecking the cows’ udders.",
    "linkDesc": "During the winter in Simo, Southern-Lapland, people have faced an annoying bird nuisance. Great tits have found a way to get inside a barn and have pecked the cows’ udders to the point where they have open wounds. Some cows have had to be put down due to disease. The first to report on the subject was a magazine called Maaseudun Tulevaisuus. According to the magazine there have been three cases so far in Lapland."
   },
   "second": {
    "name": "Seppo Äs",
    "message": "Fierce news from Venice!",
    "linkUrl": "howweirdisthat.com",
    "linkHeader": "People are skating in the Venice canals!",
    "linkDesc": "The quickly advancing climate change is also causing some exceptional weather phenomenons in Europe. The venetians were surprised by an astonishing sight when they woke up on tuesday morning; the city’s famous canals were completely frozen. The citizen’s couldn’t get to work, because traveling by gondola was out of the question. Many people spent their day off by skating through the canals."
   },
   "third": {
    "name": "Taru Aapkari",
    "message": "",
    "linkUrl": "hs.fi",
    "linkHeader": "Our teeth’s roots’ annual rings tell us about our life’s turning points.",
    "linkDesc": "Our teeth contain information about us, for example, when a woman gave birth or when her menopause began. Long term stress and even years spent in jail can be seen on the surface of our teeth cement. Tribulations can be seen on the surface of our teeth cement as differences in lightness, kind of like how a tree's growth years can be seen on it’s annual rings."
   }
  }
 },
 "framegram": {
  "message": "Dear user, the legitimacy of content is important to us. We hope that you report the posts that you find illegitimate to us.",
  "ok": "ok",
  "reported": "Reported",
  "kpl": "number of posts",
  "posts": {
   "first": {
    "name": "KimaS",
    "message": "It’s been a long time since I’ve been here! Everything went pretty well too. Maybe I should hurt my leg"
   },
   "second": {
    "name": "pave_xe",
    "message": "I just found my new favorite protein called Dude-Vitamin Pro! All I had to do was take it and do some regular meditation and I grew my biceps enormously! <b> #biceps #supplements</b>"
   },
   "third": {
    "name": "matsmek",
    "message": "We went for a veeery long walk with Mimi today and now we are starting to make some food. Have a nice saturday-night everyone! <b>#walk #dogwalk #saturday #weekend #dog #dogsofinstagram #doglovers #doglife #bae #doggie #nature #sports #mimi</B>"
   },
   "fourth": {
    "name": "gmeyrham",
    "message": "Spread the word! Para-athletic X snowboards with only 1 leg. Last week he lost his last sponsor and  now he doesn’t have money to travel to the competition at the Alps. Help him with a small donation to the account CE11435-23595"
   },
   "fifth": {
    "name": "lizzy_loe",
    "message": "I could so move here! Sleep on the floor and enjoy these TREASURES.🎶 ❤ 🎧 🎶 <b>#lovemusic #instamusic #recordstore</B>"
   },
   "sixth": {
    "name": "li4lah",
    "message": "Thank you to everyone who came over to listen to us play! The gig was sold out and the whole place was completely full!"
   },
   "seventh": {
    "name": "a.m.o.n.e.",
    "message": "🌴 ☀ 🍹 🌴 <b>#instatravel #vacation #holidaymood</b>"
   }
  },
  "likes": "likes",
  "report": "Report"
 },
 "email": {
  "notification": {
   "header": "You have a new email",
   "source": "posterstore.net",
   "address": "<a href=\"mailto:customerservice@posterstore.net\">custo</a><a href=\"mailto:customerservice@posterstore.net\">merservice@posterstore.net</a>",
   "text": "Rate your product"
  },
  "error": "System error! You need to select five messages.",
  "moveToTrash": "Move the chosen ones to the recycling bin.",
  "cancelAction": "Bring back the emails.",
  "title6": "Risk Free",
  "title5": "Bonus 500€",
  "title4": "Bad news",
  "title3": "Additional procedure",
  "title2": "Your order has been shipped",
  "title1": "Your donation",
  "shopName": "binocularstore.com",
  "shopAddress": "<a href=\"mailto:customerservice@binocularstore.com\">customerservice@binocularstore.com</a>",
  "mail1": {
   "1": "My name is Marc B. Jackson Jr. and I won 344,6 million dollars at the Powerball- jackpot on the 4th of June, 2020.",
   "2": "I will donate to 5 randomly chosen email messages, and your email address is one that I have chosen for the raffle. I will give 1 000 000 euros to you and your family in good faith.",
   "3": "Contact me by email at <b><u>marcjacksonjr85@bmail.com</u></b> to request your donation."
  },
  "mail2": {
   "1": "Dear customer,",
   "2": "Your binocularstore.com order has now been mailed and your delivery tracking number is <b>JJFI6147051898801</b>. You can track your delivery at your chosen delivery company's website.",
   "3": "You order 1 x \"Powerpro-2 8/20-binoculars\".",
   "4": "If there is any problem with your delivery, feel free to respond to this message.",
   "5": "Kindest regards, <br/>Customer service<br/><b> binocolurastore.com</b>"
  },
  "mail3": {
   "1": "Dear customer,",
   "2": "We are sorry to inform you that the delivery of your package has failed. The use of your package now requires additional procedures.",
   "3": "Tracking number"
  },
  "mail4": {
   "1": "Hello,",
   "2": "I have some bad news for you! <br/> I have broken in to your system and I have access to your messages,",
   "3": "I can make you lose your friends, colleagues and even your job.",
   "4": "CLICK THIS"
  },
  "mail5": {
   "1": "Congratulations,<br/> we are happy to inform you, that you are one of the few who were chosen to get this",
   "2": "Don’t miss your chance!",
   "3": "CLICK THIS"
  },
  "mail6": {
   "1": "I am very sorry in reaching out to you without a consent proper authorization, but I think it's wise for me to share  with you a business proposal of $18M about your last name for an investment transaction which is 100% risk free if interested please reply my email: <b><u>kufo.1217@bmail.com</u></b>"
  },
  "newMail1": "Dear customer,",
  "newMail2": "Rate your product and win a giftcard!",
  "newMail3": "You ordered 1 x “Retro savannah -poster”",
  "newMail4": "Kindest regards,<br/> Customer service<br/><b> posterstore.net</b>"
 },
 "endingScreen": {
  "title": "Congratulations!",
  "timeSpent": "You have made it out of the Troll Bunker in time",
  "linkText": "Read more about identifying fake news here (in Finnish).",
  "link": "<a href=\"https://yle.fi/valheenpaljastaja\">https://yle.fi/valheenpaljastaja</a>",
  "recommend": "Recommend to a friend",
  "shareText": "I got out of the Troll Bunker. Can you?"
 },
 "landingPage": {
  "openInBrowser": "Open the game in a browser.",
  "link": "link.yle.fi/trollibunkkeri",
  "copied": "Copied"
 }
}